// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__bkE+Y","text":"Contact_text__5RsOV","links":"Contact_links__cCDzq","link":"Contact_link__DihLc"};